import React from "react";
import AboutImg from "../assets/mateo-profile.png";

const About = () => {
  return (
    <section className="bg-secondery text-white px-5 py-32" id="about">
      <div className="container mx-auto grid md:grid-cols-2 items-center justify-center md:justify-between">
        <div className="about-info">
          <h2 className="text-4xl font-bold mb-5 border-b-[5px] w-[180px] border-zinc-500 pb-2">
            Acerca de mí
          </h2>

          <p className="pb-5">
            Hola, Mi nombre es Mateo Peñeherrera, y soy un Analista de Sistemas que le tomo mucho amor al Desarrollo Web.
            Me encanta proponer soluciones creativas a problemas.
            La tecnología desde pequeño siempre fue mi pasión.
          </p>
          <p className="pb-5">
            Tengo mucha experiencia con Frontend como: React.js, Angular, Axios, Tailwind CSS, SaSS, Css3 y muchos mas.
          </p>

          <p className="pb-5">En backend he trabajado con Laravel, Symfony y Django</p>

          <p className="pb-5">
            Tambien me dedico al mantenimiento de equipos y reparación de computadores y servidores. Diseño y configuro redes de Internet.
          </p>

          <p className="pb-5">"Soy un desarrollador web apasionado y altamente motivado con más de 3 años de experiencia en el desarrollo de soluciones web eficientes y de alta calidad. Con una sólida formación, tengo una comprensión profunda de los lenguajes de programación y las metodologías de desarrollo. Me esfuerzo por crear soluciones innovadoras y fáciles de usar que mejoran la experiencia de los usuarios y satisfacen sus necesidades. Estoy comprometido a mantenerme actualizado con las últimas tendencias y tecnologías en el desarrollo web para garantizar el éxito de mis proyectos.</p>
        </div>

        <div className="about-img">
          <center>
            <img
              src={AboutImg}
              alt="coding illustration"
              className="max-w-[70%] md:ml-auto"
            />
          </center>
        </div>
      </div>
    </section>
  );
};

export default About;
